import React from 'react'
import classnames from 'classnames'

import './DataTable.scss'

const DataTable = ({ className, children }) => {
  return (
    <div className={classnames('datatable', className)}>{children}</div>
  )
}

export default DataTable
